import { createContext, ReactNode, useContext } from "react";
import { MediaVersion } from "@/types/mediaArtifact";

type MediaKind = "image" | "video" | "avatar";

export interface MediaPreviewContextValue {
  mediaType: MediaKind;
  current: MediaVersion;
  canEdit: boolean;
  showDownload: boolean;
  replacing: boolean;
  onRemix: () => void;
  onDownload: () => Promise<void>;
  onReplace: () => void;
}

const MediaPreviewContext = createContext<MediaPreviewContextValue | null>(
  null
);

interface MediaPreviewProviderProps {
  value: MediaPreviewContextValue;
  children: ReactNode;
}

export function MediaPreviewProvider(props: MediaPreviewProviderProps) {
  const { value, children } = props;
  return (
    <MediaPreviewContext.Provider value={value}>
      {children}
    </MediaPreviewContext.Provider>
  );
}

export function useMediaPreviewContext() {
  const context = useContext(MediaPreviewContext);
  if (!context) {
    throw new Error(
      "useMediaPreviewContext must be used within MediaPreviewProvider"
    );
  }
  return context;
}
